// Site-wide constants (contact info, services, FAQs, testimonials)

export const CONTACT = {
  phone: "321-424-3243",
  phoneNote: "Call Screened — Text Only",
  email: "Contact@jkawesomedeedsLLC.com",
  company: "J K Awesome Deeds LLC",
  tagline: "Real Estate Solutions Built on Compassion",
};

export const PROGRAMS = [
  {
    id: "pre-foreclosure",
    label: "Pre-Foreclosure Prevention",
    short: "Stop Foreclosure",
    blurb:
      "Facing foreclosure? You have more options than the bank tells you. We negotiate directly with lenders to halt the process and protect your equity.",
    bullets: [
      "Free, confidential consultation",
      "Lender negotiation & loss mitigation",
      "Loan modification & forbearance options",
      "Protect your credit and your home",
    ],
    cta: "Get Help Now",
    accent: "forest",
  },
  {
    id: "short-sale",
    label: "Short Sales Expedited",
    short: "Short Sale Help",
    blurb:
      "When you owe more than your home is worth, our expedited short-sale process gets you out from underwater — fast, with no out-of-pocket cost.",
    bullets: [
      "Bank pays all closing costs",
      "Most approvals in 30–60 days",
      "Walk away free of remaining debt",
      "Specialist team — 1,000+ closings",
    ],
    cta: "Start Short Sale",
    accent: "gold",
  },
  {
    id: "cash-buyer",
    label: "Fidelity House Buyers",
    short: "Cash Offer",
    blurb:
      "Need to sell fast? We buy houses in any condition, any situation. Fair cash offers in 24 hours. Close in as little as 7 days. No fees, no repairs.",
    bullets: [
      "Cash offer within 24 hours",
      "Close in 7 days or your timeline",
      "Sell as-is — no repairs needed",
      "Zero commissions or fees",
    ],
    cta: "Get Cash Offer",
    accent: "forest",
  },
];

export const HOW_IT_WORKS = [
  {
    n: "01",
    title: "Tell Us Your Situation",
    body:
      "Share a few details — confidentially. We listen first, advise second. No pressure, no judgment.",
  },
  {
    n: "02",
    title: "Receive a Tailored Plan",
    body:
      "Our specialists evaluate your property, your timeline, and your goals — then design the path that fits.",
  },
  {
    n: "03",
    title: "Move Forward With Certainty",
    body:
      "Whether stopping foreclosure or closing in 7 days, you stay informed and in control every step.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Javier and the JK team stopped my foreclosure 9 days before the auction. I still own my home today. I will never be able to repay them.",
    name: "Maria S.",
    role: "Homeowner — Orlando, FL",
  },
  {
    quote:
      "We were $40k underwater after my husband lost his job. The short sale closed in 47 days, the bank forgave the difference. A weight off our shoulders.",
    name: "Robert & Lynn K.",
    role: "Sellers — Kissimmee, FL",
  },
  {
    quote:
      "Inherited a property I didn't want, full of repairs. Got a cash offer in 18 hours, closed in a week. Couldn't have asked for a smoother process.",
    name: "Daniel T.",
    role: "Cash Sale — Tampa, FL",
  },
  {
    quote:
      "Compassionate, ethical, and they actually deliver what they promise. Rare combination in this industry.",
    name: "Patricia G.",
    role: "Homeowner — Lakeland, FL",
  },
];

export const FAQS = [
  {
    q: "How much does it cost to work with you?",
    a: "Nothing. Our pre-foreclosure, short-sale, and cash-buyer programs all come at zero out-of-pocket cost to homeowners. We are paid by the transaction, by the lender, or by our investor partners — never by you.",
  },
  {
    q: "How fast can you stop a foreclosure?",
    a: "We have halted foreclosures with as little as 72 hours notice — but the earlier you reach out, the more options you have. The moment you receive a notice of default, call us.",
  },
  {
    q: "How is a short sale different from foreclosure?",
    a: "A short sale lets you sell your home for less than you owe with the lender's approval. It is far less damaging to your credit than foreclosure, and you typically walk away free of any remaining debt.",
  },
  {
    q: "Do you really buy houses in any condition?",
    a: "Yes. Fire damage, hoarder situations, code violations, inherited properties, tenants in place — we have bought it all. You sell as-is. We handle everything.",
  },
  {
    q: "How fast can you make a cash offer?",
    a: "Within 24 hours of seeing the property. We can close in as little as 7 days, or on whatever timeline works best for you.",
  },
  {
    q: "Will this affect my credit?",
    a: "Stopping the foreclosure or completing a short sale is dramatically less damaging to your credit than letting a foreclosure complete. Our team will walk you through every implication before you decide.",
  },
];
